var UrlParser = function() {};

UrlParser.toQueryString = function(object) {
    var queryString = '?';
    for (var key in object) {
        if (object.hasOwnProperty(key) && typeof object[key] !== 'undefined' && object[key] !== null) {
            if (object[key] && typeof object[key] === 'object' && object[key].constructor === Array) {
                var arrayQuery = '';
                object[key].forEach(function(e) {
                    arrayQuery += key + '=' + e + '&';
                });
                queryString += arrayQuery;
            } else {
                queryString += key + '=' + object[key] + '&';
            }
        }
    }
    queryString = queryString.slice(0, -1); // remove last & or ?
    return queryString;
};

UrlParser.prototype.parse = function(value) {
    if (!value || value.length == 0) {
        return '';
    }

    var testValue = value.toLowerCase();

    if (testValue.substring(0, 4) != 'http' && testValue.substring(0, 5) != 'https') {
        return window.location.protocol + '//' + value;
    }

    return value;
};

///Returns a object of query strings
UrlParser.prototype.parseQueryString = function(queryString) {
    var params = {},
        queries,
        temp,
        i,
        l;

    if (!queryString || queryString.length == 0) {
        return params;
    }

    //make sure queryString is not full url
    if (queryString.indexOf('?') !== -1) {
        queryString = queryString.substring(queryString.indexOf('?') + 1);
    }

    // split into key/value pairs
    queries = queryString.split('&');

    // convert array of strings into an object
    for (i = 0, l = queries.length; i < l; i++) {
        temp = queries[i].split('=');
        params[temp[0]] = temp[1];
    }

    return params;
};

///Converts object to query string format
UrlParser.prototype.convertObjectToQueryString = function(object) {
    var queryString = '?';

    if (object) {
        for (var o in object) {
            if (o && (object[o] || object[o] == 0)) {
                queryString += o + '=' + encodeURIComponent(object[o]) + '&';
            }
        }
    }

    return queryString === '?' ? '' : queryString.substring(0, parseInt(queryString.length, 10) - 1);
};

///Converts object to query string format without encoding
UrlParser.prototype.convertObjectToQueryStringWithoutEncoding = function(object) {
    var queryString = '?';

    if (object) {
        for (var o in object) {
            if (o && typeof object[o] !== 'undefined' && object[o] !== null) {
                queryString +=
                    o +
                    '=' +
                    object[o]
                        .toString()
                        .replace(/&/g, '%26')
                        .replace(/=/g, '%3D') +
                    '&';
            }
        }
    }

    return queryString === '?' ? '' : queryString.substring(0, queryString.length - 1);
};

//Helpful when multiples of the same query is allowed
UrlParser.prototype.convertArrayToQueryString = function(key, array) {
    var queries = '';

    for (var i = 0, len = array.length; i < len; i += 1) {
        if (array[i]) {
            if (!queries) {
                queries += key + '=' + array[i];
            } else {
                queries += '&' + key + '=' + array[i];
            }
        }
    }

    return queries;
};

export default UrlParser;
